"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataPromise = getDataPromise;
exports.getDataPromiseWithQueryString = getDataPromiseWithQueryString;

var _queryString = require("query-string");

var _baseFetchPromise = require("./baseFetchPromise");

var _defaultFetchOptions = _interopRequireDefault(require("./defaultFetchOptions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function appendDateParameterToPath(path) {
  // Check readme v1.6.1 Edge Patch
  var separator = path.indexOf('?') === -1 ? '?' : '&';
  return "".concat(path).concat(separator, "k=").concat(Date.now());
}

function getDataPromise(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var fetchOptions = _objectSpread(_objectSpread({}, (0, _defaultFetchOptions["default"])()), {}, {
    method: 'GET'
  }, options); // prettier-ignore


  return !isCached ? (0, _baseFetchPromise.baseFetchPromiseWithResponse)(appendDateParameterToPath(path), fetchOptions) : (0, _baseFetchPromise.baseFetchPromiseWithResponse)(path, fetchOptions);
} // eslint-disable-next-line max-params


function getDataPromiseWithQueryString(path, query) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isCached = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var fetchOptions = _objectSpread(_objectSpread({}, (0, _defaultFetchOptions["default"])()), {}, {
    method: 'GET'
  }, options);

  var uri = "".concat(path, "?").concat((0, _queryString.stringify)(query)); // prettier-ignore

  return !isCached ? (0, _baseFetchPromise.baseFetchPromiseWithResponse)(appendDateParameterToPath(uri), fetchOptions) : (0, _baseFetchPromise.baseFetchPromiseWithResponse)(path, fetchOptions);
}